import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
  standalone: false,
})
export class ProgressComponent {
  @Input() max: number = 100;
  @Input() current: number = 0;
  @Input() message!: string;
  @Input() showPercentProgress: boolean = true;

  getProgressInPercent(): number {
    return Math.round((100 * this.current) / this.max);
  }
}
